import { render, staticRenderFns } from "./globalMenuDropdown.vue?vue&type=template&id=30a84548&"
import script from "./globalMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./globalMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./globalMenuDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports